'use client'

import Link from 'next/link'
import AirportCombobox, { AIRPORT_DB } from './AirportCombobox'
import destinations from '@/data/destinations-client.json'

export default function DealsOriginSection({
  currentUser, airports, origin, isPaid, AIRPORT_LIMIT,
  showAirportLock, setShowAirportLock,
  liveDealCounts, allDestinations, destFilter, updateDestFilter,
  flexDays, homeAirports,
  selectedOriginAirports = [], setSelectedOriginAirports,
  onChangeOrigin,
}) {
  return (
    <>

      {currentUser && homeAirports.length > 0 && (
        <div className="mb-5">
          <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500">Departure</p>
          <div className="flex flex-wrap gap-2">
            {homeAirports.map((ap) => {
              const active = selectedOriginAirports.includes(ap)
              const count = liveDealCounts[ap] ?? 0
              return (
                <button
                  key={ap}
                  onClick={() => setSelectedOriginAirports(
                    active
                      ? selectedOriginAirports.filter((a) => a !== ap)
                      : [...selectedOriginAirports, ap]
                  )}
                  className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                    active
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-gray-700 ring-1 ring-gray-200 hover:bg-gray-50'
                  }`}
                >
                  {AIRPORT_DB[ap]?.city ?? ap}
                  <span className={`text-xs ${active ? 'text-blue-200' : 'text-gray-400'}`}>{ap}</span>
                  {count > 0 && (
                    <span className={`text-xs ${active ? 'text-blue-200' : 'text-gray-400'}`}>· {count}</span>
                  )}
                </button>
              )
            })}
            {selectedOriginAirports.length > 0 && (
              <button
                onClick={() => setSelectedOriginAirports([])}
                className="rounded-full px-3 py-1.5 text-sm font-medium text-gray-400 ring-1 ring-gray-200 bg-white hover:bg-gray-50 transition-colors"
              >
                Clear
              </button>
            )}
          </div>
        </div>
      )}

      {currentUser && homeAirports.length === 0 && airports.length > 0 && (
        <div className="mb-5">
          <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500">Flying from</p>
          <AirportCombobox
            airports={isPaid ? airports : [origin]}
            value={origin}
            onChange={onChangeOrigin}
            getLabel={(iata) => {
              const c = liveDealCounts[iata] ?? 0
              return c > 0 ? `${c} live deal${c !== 1 ? 's' : ''}` : '0 deals — check back'
            }}
            placeholder="Search departure airport…"
            clearable={false}
          />
          {showAirportLock && (
            <p className="mt-1.5 text-xs rounded-lg bg-amber-50 px-3 py-2 text-amber-700">
              🔒 Browsing multiple airports requires{' '}
              <Link href="/pricing" className="font-semibold underline">Plus or Pro</Link>.
            </p>
          )}
          {!isPaid && !showAirportLock && airports.length > AIRPORT_LIMIT && (
            <p className="mt-1.5 text-xs text-gray-400">
              🔒 {airports.length - 1} more airport{airports.length - 1 !== 1 ? 's' : ''} on{' '}
              <Link href="/pricing" className="text-blue-500 hover:underline">Plus/Pro</Link>
            </p>
          )}
        </div>
      )}


      {flexDays > 0 && currentUser && (
        <p className="mb-3 text-xs text-blue-600 text-center">✦ ±{flexDays}-day flexibility active</p>
      )}
    </>
  )
}
